import React from 'react';
import BrandIdentity from '../../components/BrandIdentity';
import AppLayout from '../../layouts/AppLayout';
import './styles.css';

function BrandIdentityPage() {
  return (
    <AppLayout title="Identidade Visual" subtitle="Cores e branding" fullWidth>
      <BrandIdentity />
    </AppLayout>
  );
}

export default BrandIdentityPage;
